export const PAGE_SIZE = 12;
export const REFRESH_INTERVAL_MS = 10 * 60_000;
export const ORDER_POLL_MS = 30_000;
export const POINTS_PER_RUPEE = 10;
/** Matches the backend's DELIVERY_DAYS: every order is promised within this many days. */
export const DELIVERY_DAYS = 10;
/** Matches the backend's MAX_DELIVERY_FEE_PAISE (₹100): the most a transportation charge may be. */
export const MAX_DELIVERY_FEE_RUPEES = 100;
/** Matches the backend's CREDIT_DELAY_DAYS: earned points become spendable this long after delivery. */
export const CREDIT_DELAY_DAYS = 3;
export const PIN_CODE_PATTERN = '[1-9][0-9]{5}';
export const PIN_CODE_REGEX = new RegExp(`^${PIN_CODE_PATTERN}$`);
